module.exports = __webpack_public_path__ + "static/media/black_tow.ea98c7e4.png";